import React, { useState } from "react";
import styles from "./FeeComponent.module.css";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import { IoDocumentTextOutline } from "react-icons/io5";

const FeeComponent = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    rate: "",
    code: "",
  });

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleCancel = () => {
    dispatch(closeModal());
  };

  const handleSave = () => {
    if (
      !formData.name ||
      !formData.description ||
      !formData.rate ||
      !formData.code
    ) {
      alert("Please fill all required fields.");
      return;
    }
    console.log("Fee component submitted:", formData);
    dispatch(closeModal());
  };

  return (
    <div className={styles.modal}>
      <div className={styles.header}>
        <HeadingAndIcon
          icon={<IoDocumentTextOutline  />}
          heading="Create Fee Component"
        />
        <ToClose onClose={handleCancel} />
      </div>

      <div className={styles.content}>
        <HeadingAndData
          label="Name"
          name="name"
          placeholder="Enter your name"
          value={formData.name}
          onChange={handleChange("name")}
          required
        />

        {/* Custom styled textarea input */}
        <div className={styles.inputBlock}>
          <label htmlFor="description" className={styles.inputLabel}>
            Description<span className={styles.required}> *</span>
          </label>
          <textarea
            id="description"
            name="description"
            className={styles.inputField}
            placeholder="Please enter description"
            value={formData.description}
            onChange={handleChange("description")}
            required
            rows={3}
            style={{ resize: "none" }}
          />
        </div>

        <HeadingAndData
          label="Rate for charges"
          name="rate"
          placeholder="Please enter value"
          value={formData.rate}
          onChange={handleChange("rate")}
          required
        />

        <HeadingAndData
          label="Item Code"
          name="code"
          placeholder="Please enter item code"
          value={formData.code}
          onChange={handleChange("code")}
          required
        />

        <div className={styles.actions}>
          <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
        </div>
      </div>
    </div>
  );
};

export default FeeComponent;
